import { StoryDto } from "dtos/frankenstories/StoryDto";
import { Link } from "react-router-dom";
import { RouteLink } from "Routes";
import { StoryStats } from "components/StoryStats";
import { useEffect, useState } from "react";
import clsx from "clsx";
import ReactTimeago from "react-timeago";

export const GameCard = (props: { g: StoryDto; isAnonymous: boolean; showDate: boolean }) => {
    const { g, isAnonymous, showDate } = props;

    const { code, dateModified, id, name, playerCount, roundCount, imageUrl, isImageHidden, prompt } = g;

    const [loaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsLoaded(true);
        }, 100);
    }, []);

    return (
        <Link
            key={id}
            style={{ maxWidth: 350 }}
            to={isAnonymous ? RouteLink.discoverHallOfFameStory(code) : RouteLink.gamesCompletedGame(code)}
            className={clsx(
                "my-frankenstories__item rounded overflow-hidden shadow animate mx-auto",
                loaded ? "opacity-100" : "opacity-0",
            )}
        >
            {imageUrl && prompt && (
                <div className="text-center overflow-hidden">
                    <img alt="" src={imageUrl} className={clsx("img-fluid", isImageHidden && "blur")} />
                </div>
            )}

            <div className="d-flex gap-3 flex-column p-3">
                <div className="h5">{name}</div>

                <div className="hstack justify-content-between">
                    <StoryStats playerCount={playerCount} roundCount={roundCount} />

                    {showDate && (
                        <div className="small text-dark">
                            <ReactTimeago date={new Date(dateModified)} />
                        </div>
                    )}
                </div>
            </div>
        </Link>
    );
};
